import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "workflows-layout" }
const _hoisted_2 = { class: "workflow-sidebar" }
const _hoisted_3 = { class: "d-flex align-center justify-space-between ml-1 workflow-sidebar-header" }
const _hoisted_4 = { class: "workflow-history-actions" }
const _hoisted_5 = { class: "workflow-main" }
const _hoisted_6 = {
  key: 1,
  class: "factory-empty-pane"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_FactoryEditor = _resolveComponent("FactoryEditor")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "workflows-shell ma-0 pa-0",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("aside", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              icon: "mdi-note-plus-outline",
              click: _ctx.addFactory,
              size: "large",
              tooltip: "New Factory",
              variant: "plain",
              density: "compact",
              color: "primary"
            }, null, 8, ["click"]),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_tooltip, {
              text: "Factories is currently in beta and may have bugs.",
              location: "top"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_chip, _mergeProps(props, {
                  size: "small",
                  density: "compact",
                  color: "secondary",
                  class: "mx-auto"
                }), {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" BETA ")
                  ])),
                  _: 2,
                  __: [4]
                }, 1040)
              ]),
              _: 1
            }),
            _createVNode(_component_v_tooltip, {
              text: "Refresh Factories",
              location: "top"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps(props, {
                  color: "primary",
                  variant: "text",
                  density: "compact",
                  icon: "",
                  loading: _ctx.refreshingFactories,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshFactoriesView(true)))
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("mdi-refresh")
                      ])),
                      _: 1,
                      __: [5]
                    })
                  ]),
                  _: 2
                }, 1040, ["loading"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_v_list, {
            class: "mt-2 workflow-history-list",
            "bg-color": "transparent",
            density: "compact"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.factoryList, (factory) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: factory.id,
                  active: _ctx.selectedFactoryId === factory.id,
                  "active-class": "workflow-history-item--active",
                  class: "workflow-history-item",
                  lines: "one",
                  onClick: ($event: any) => (_ctx.selectedFactoryId = factory.id)
                }, {
                  title: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, {
                      class: "workflow-history-title",
                      title: factory.name
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(factory.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["title"])
                  ]),
                  append: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_v_tooltip, { location: "top" }, {
                        activator: _withCtx(({ props: tooltip }) => [
                          _createVNode(_component_v_icon, _mergeProps({ ref_for: true }, tooltip, {
                            onClick: _withModifiers(($event: any) => (_ctx.handleDeleteClick($event, factory.id)), ["stop"]),
                            size: "small",
                            color: "primary",
                            class: "workflow-delete-icon"
                          }), {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createTextVNode(" mdi-delete-forever-outline ")
                            ])),
                            _: 2,
                            __: [6]
                          }, 1040, ["onClick"])
                        ]),
                        default: _withCtx(() => [
                          _cache[7] || (_cache[7] = _createElementVNode("span", null, "Delete", -1))
                        ]),
                        _: 2,
                        __: [7]
                      }, 1024)
                    ])
                  ]),
                  _: 2
                }, 1032, ["active", "onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("section", _hoisted_5, [
          (_ctx.selectedFactoryId)
            ? (_openBlock(), _createBlock(_component_v_window, {
                key: 0,
                modelValue: _ctx.selectedFactoryId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedFactoryId) = $event)),
                class: "fill-height"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.factoryList, (factory) => {
                    return (_openBlock(), _createBlock(_component_v_window_item, {
                      key: factory.id,
                      value: factory.id,
                      class: "workflow-scroll"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_FactoryEditor, {
                          id: factory.id,
                          "is-active": _ctx.selectedFactoryId === factory.id
                        }, null, 8, ["id", "is-active"])
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_v_card, {
                  class: "factory-empty-card",
                  variant: "outlined"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, { class: "pa-8 text-center text-medium-emphasis" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          icon: "mdi-factory",
                          size: "48",
                          color: "grey"
                        }),
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-h6 mt-4 mb-2" }, "No factories yet", -1)),
                        _cache[9] || (_cache[9] = _createElementVNode("div", null, "Create an agent or workflow, then add a factory from the sidebar.", -1))
                      ]),
                      _: 1,
                      __: [8,9]
                    })
                  ]),
                  _: 1
                })
              ]))
        ])
      ]),
      _createVNode(_component_ConfirmationDialog, {
        modelValue: _ctx.showDeleteConfirmation,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showDeleteConfirmation) = $event)),
        title: "Confirm Factory Deletion",
        message: "Are you sure you want to delete this factory?",
        "item-type": "factory",
        "item-name": _ctx.factoryToDeleteName,
        onConfirm: _ctx.executeDeleteFactory,
        onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDeleteConfirmation = false))
      }, null, 8, ["modelValue", "item-name", "onConfirm"])
    ]),
    _: 1
  }))
}